import { CircularProgress, Grid, IconButton, TextField } from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import CheckIcon from '@material-ui/icons/Check'
import { useOptionOtherItem } from './OptionOtherItem.hooks'

const OptionOtherItem = props => {
	const [
		{ value, gridWidth, classes, disabled, loading, checked, placeholder, readOnly },
		{ handleChange, handlerClick, handleKeyUp, handleFocus, handleBlur },
	] = useOptionOtherItem(props)

	return (
		<Grid className="q-button-container" item xs={12} sm={gridWidth}>
			<div className={clsx(classes.wrapper, 'q-container-other-option-wrapper')}>
				<TextField
					className={clsx(classes.textInput, 'q-input')}
					aria-label="other Answer"
					name="other_answer"
					placeholder={placeholder}
					fullWidth
					disabled={disabled}
					onKeyUp={handleKeyUp}
					onFocus={handleFocus}
					onBlur={handleBlur}
					InputProps={{
						readOnly,
						startAdornment: checked ? <CheckIcon className={classes.checkIcon} /> : null,
						endAdornment: value.length ? (
							<IconButton className={classes.buttonIcon} onClick={handlerClick}>
								<CheckBoxIcon className={classes.icon} />
							</IconButton>
						) : null,

						classes: {
							root: classes.root,
							adornedEnd: classes.adornedEnd,
							input: classes.input,
							adornedStart: classes.adornedStart,
							notchedOutline: classes.notchedOutline,
							focused: classes.focused,
						},
					}}
					inputProps={{
						maxLength: 1000,
					}}
					value={value}
					onChange={handleChange}
				/>
				{loading && <CircularProgress size={24} className={classes.progress} />}
			</div>
		</Grid>
	)
}

OptionOtherItem.propTypes = {
	gridWidth: PropTypes.number,
	onClick: PropTypes.func,
	optionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	checked: PropTypes.bool,
	loading: PropTypes.bool,
	disabled: PropTypes.bool,
	multiple: PropTypes.bool,
	value: PropTypes.string,
	onChange: PropTypes.func,
}

export default memo(OptionOtherItem)
